 // import Swiper JS
 import Swiper, {
   Autoplay,
   Pagination
 } from 'swiper';
 // import Swiper styles
 import 'swiper/css';
 import 'swiper/css/pagination';

 // configure Swiper to use modules
 Swiper.use([Autoplay, Pagination]);


 export function initVerticalSlider() {
   if (window.acf) {
     window.acf.addAction(
       'render_block_preview/type=vertical-carousel',
       verticalSlider
     );
   }
 }

 export function verticalSlider() {

   let verticalEl = document.querySelector('.vertical-carousel');
   if (!verticalEl)
     return;

   window.onload = (event) => {
     const swiperVertical = new Swiper('.vertical-carousel > .swiper', {
       // Optional parameters
       direction: 'horizontal',
       autoplay: {
         delay: 7000,
         disableOnInteraction: false,
       },
       speed: 500,
       loop: false,
       grabCursor: true,
       keyboardControl: true,
       centeredSlides: true,
       pagination: {
         el: '.swiper-pagination',
         type: 'bullets',
         clickable: true
       }
     });
   };

 }
